// removed by extract-text-webpack-plugin
module.exports = {"tip":"tip__1e3Yl","congested":"congested__2-yb4","mandate-tips":"mandate-tips__8wcT2","tip-image":"tip-image__10WhK","tip-text":"tip-text__6YUrT"};


//////////////////
// WEBPACK FOOTER
// ./styles/plan/checkedTips.scss
// module id = 240
// module chunks = 68